import { useSelector } from 'react-redux'
import { selectAdditionalSaleDataByName, selectAddressesData } from '../SubscriptionFormSelectors'
import useAdditionalSaleFormData from '../../Components/AdditionalSales/useAdditionalSaleFormData'
import { useTranslation } from 'react-i18next'
import { isProxiserveEligible } from '@/containers/SubscriptionFormPageNew/Components/AdditionalSales/sales/LeadProxiserveSale/isProxiserveEligible'

const useAddressRelatedScript = () => {
  const addressRelatedScripts = {}
  let leadProxiserve = null
  const addresses = useSelector(selectAddressesData)
  const { retrieveProductsListOfSale } = useAdditionalSaleFormData()
  const { t } = useTranslation()
  const retrieveMaxCreditsOfProducts = products => {
    return products.reduce((max, product) => {
      return (product.credits?.credits || 0) > (max.credits?.credits || 0) ? product : max
    }, products[0])
  }

  // LAE Rachat de crédit - Lead Eddy Propriétaire
  const productListLeadEddyProprietaire = retrieveProductsListOfSale('leadEddyProprietaire')
  const productWithHighestCreditsEddyProprietaire = retrieveMaxCreditsOfProducts(productListLeadEddyProprietaire)
  const currentLeadEddyProprietaireData = useSelector(selectAdditionalSaleDataByName('leadEddyProprietaire'))
  const eddyProprietaireLeadSold = currentLeadEddyProprietaireData?.zohoContractDetailId?.length > 0

  // LAE Assurance Emprunteur - Lead Assurance Emprunteur
  const productListLeadAssuranceEmprunteur = retrieveProductsListOfSale('leadAssuranceEmprunteur')
  const productWithHighestCreditsAssuranceEmprunteur = retrieveMaxCreditsOfProducts(productListLeadAssuranceEmprunteur)
  const currentLeadAssuranceEmprunteurData = useSelector(selectAdditionalSaleDataByName('leadAssuranceEmprunteur'))
  const assuranceEmprunteurLeadSold = currentLeadAssuranceEmprunteurData?.zohoContractDetailId?.length > 0

  // Voltalis Bizdev
  const productListLeadVoltalisBizdev = retrieveProductsListOfSale('leadVoltalisBizdev')
  const productWithHighestCreditsVoltalisBizdev = retrieveMaxCreditsOfProducts(productListLeadVoltalisBizdev)
  const currentLeadVoltalisBizdevData = useSelector(selectAdditionalSaleDataByName('leadVoltalisBizdev'))
  const voltalisBizdevLeadSold = currentLeadVoltalisBizdevData?.zohoContractDetailId?.length > 0

  // lead tucoenergie
  const productListLeadTucoenergie = retrieveProductsListOfSale('leadTucoenergie')
  const productWithHighestCreditsTucoenergie = retrieveMaxCreditsOfProducts(productListLeadTucoenergie)
  const currentLeadTucoenergieData = useSelector(selectAdditionalSaleDataByName('leadTucoenergie'))
  const tucoenergieLeadSold = currentLeadTucoenergieData?.zohoContractDetailId?.length > 0

  const productListLeadProxiserve = retrieveProductsListOfSale('leadProxiserve')
  const productWithHighestCreditsProxiserve = retrieveMaxCreditsOfProducts(productListLeadProxiserve)
  const currentLeadProxiserveData = useSelector(selectAdditionalSaleDataByName('leadProxiserve'))
  const proxiserveLeadSold = currentLeadProxiserveData?.zohoContractDetailId?.length > 0

  if (Object.entries(addresses).length) {
    Object.entries(addresses).forEach(([index, address]) => {
      const isOwnerOrLandlord = address?.tenantType === 'owner' || address?.tenantType === 'landlord'
      const hasHeatingEnergy = address?.heatingEnergy === 'elec'
      const isHouse = address?.housingType === 'house'
      if (
        isOwnerOrLandlord &&
        !addressRelatedScripts.leadEddyProprietaire &&
        productListLeadEddyProprietaire.length > 0
      ) {
        addressRelatedScripts.leadEddyProprietaire = {
          name: 'leadEddyProprietaire',
          title: 'Lead LAE Rachat de crédit',
          description: t('subscriptionForm:credit_booster.eddy'),
          credits: productWithHighestCreditsEddyProprietaire?.credits?.credits || null,
          sold: eddyProprietaireLeadSold,
          icon: 'sales-leadEddyProprietaire',
        }
      }
      if (
        isOwnerOrLandlord &&
        !addressRelatedScripts.leadAssuranceEmprunteur &&
        productListLeadAssuranceEmprunteur.length > 0
      ) {
        addressRelatedScripts.leadAssuranceEmprunteur = {
          name: 'leadAssuranceEmprunteur',
          title: 'Lead Assurance Emprunteur',
          description: t('subscriptionForm:credit_booster.lae'),
          credits: productWithHighestCreditsAssuranceEmprunteur?.credits?.credits || null,
          sold: assuranceEmprunteurLeadSold,
          icon: 'sales-leadAssuranceEmprunteur',
        }
      }
      if (hasHeatingEnergy && !addressRelatedScripts.leadVoltalisBizdev && productListLeadVoltalisBizdev.length > 0) {
        addressRelatedScripts.leadVoltalisBizdev = {
          name: 'leadVoltalisBizdev',
          title: 'Voltalis',
          description: t('subscriptionForm:credit_booster.voltalis'),
          credits: productWithHighestCreditsVoltalisBizdev?.credits?.credits || null,
          sold: voltalisBizdevLeadSold,
          icon: 'sales-leadVoltalisBizdev',
        }
      }
      if (
        isHouse &&
        isOwnerOrLandlord &&
        !addressRelatedScripts.leadTucoenergie &&
        productListLeadTucoenergie.length > 0
      ) {
        addressRelatedScripts.leadTucoenergie = {
          name: 'leadTucoenergie',
          title: 'Lead Tucoenergie',
          description: t('subscriptionForm:credit_booster.tucoenergie'),
          credits: productWithHighestCreditsTucoenergie?.credits?.credits || null,
          sold: tucoenergieLeadSold,
          icon: 'sales-leadTucoenergie',
        }
      }
      if (isProxiserveEligible(address) && !leadProxiserve && productListLeadProxiserve.length > 0) {
        leadProxiserve = {
          name: 'leadProxiserve',
          title: 'Proxiserve',
          description: t('subscriptionForm:credit_booster.proxiserve'),
          credits: productWithHighestCreditsProxiserve?.credits?.credits || null,
          sold: proxiserveLeadSold,
          icon: 'sales-leadProxiserve',
        }
      }
    })
  }

  return {
    addressRelatedScripts,
    leadProxiserve,
  }
}

export default useAddressRelatedScript
